import { render } from "./MainModal.vue?vue&type=template&id=5094cca3&scoped=true"
import script from "./MainModal.vue?vue&type=script&lang=js"
export * from "./MainModal.vue?vue&type=script&lang=js"

import "./MainModal.vue?vue&type=style&index=0&id=5094cca3&scoped=true&lang=css"

import exportComponent from "/Users/iyongmin/Documents/twin-cosmos/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5094cca3"]])

export default __exports__